import { Modal } from "reactstrap";
import { updateCampaignState } from "../../VideoActions";
import crossIcon from "@src/assets/images/vyrill/icons/cross_icon.png";
import { useDispatch, useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import moment from "moment";
import {
  rewardIcon,
  calenderIcon,
  timeIcon,
  timeLimiIcon,
  copyIcon,
  qrCodeIcon,
} from "../../../../Shared/SVGs/Shared";
import { useState } from "react";
import {
  updateCampaignFields,
  updateCampaignState as updateCreateCampaignState,
} from "../../../CreateCampaign/CampaignActions";
import { useNavigate } from "react-router-dom";
import QrCodeModal from "./QrCodeModal";

const ShowCampaignDetal = () => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpenQr = () => {
    setOpen(true);
  };
  const handleCloseQr = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  const showCampaignDetail = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignDetail
  );

  const videoData = useSelector(
    (state) => state.videoData.campaign_details_list
  );
  const campaignData = videoData?.campaign_details;

  const campaignUrl = `${process.env.REACT_APP_CAMPAGIN_URL}/form/${campaignData?._id}/landing`;
  const handleCopyClick = () => {
    setCopied(!copied);
    navigator.clipboard.writeText(campaignUrl);
    setTimeout(() => {
      setCopied(false);
    }, 500);
  };
  const navigate = useNavigate();
  const handleQrClick = (campaignId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("id", campaignId);
    navigate("/create_campaign?" + queryParams.toString());
    dispatch(updateCreateCampaignState({ activeStep: 5 }));
    dispatch(
      updateCampaignState({ showCampaignStep: true, showCampaignDetail: false })
    );
    
    dispatch(
      updateCampaignFields({
        banner_share_url: "",
        banner_with_qr: "",
      })
    );
  };

  const headline = (
    <>
      <div className="preview-headline">{campaignData?.name}</div>
    </>
  );
  const hashtags = (
    <>
      <div className="hash-tags">{campaignData?.hash_tag}</div>
    </>
  );

  const productimage = (
    <>
      <div>
        <img
          src={
            campaignData?.banner_url ||
            require("@src/assets/images/campaign-default.png").default
          }
          alt=""
          style={{
            border: "1px solid #23BBB8",
            width: "599px",
            height: "365px",
            objectFit:
              campaignData?.bannerRenderAs === "Fill"
                ? "cover"
                : campaignData?.bannerRenderAs === "Fit"
                ? "contain"
                : "contain",
          }}
        />
      </div>
    </>
  );

  const discriptions = (
    <>
      <div
        className="campaign-discription"
        dangerouslySetInnerHTML={{ __html: campaignData?.campaign_description }}
      />
    </>
  );

  const termAndCondition = (
    <>
      <PerfectScrollbar
        style={{
          height: "197px",
          padding: "10px 15px",
          marginTop: "25px",
        }}
        className="detail-box"
        options={{ wheelPropagation: true, maxScrollbarLength: 70 }}
      >
        <div
          // className="preview-terms"
          dangerouslySetInnerHTML={{
            __html: campaignData?.terms_and_conditions,
          }}
        />
      </PerfectScrollbar>
    </>
  );

  const Reward = (
    <>
      <div className="reward">
        {campaignData?.reward_type === "Cash" && "$"}
        {campaignData?.reward_type !== "Other" && campaignData?.reward}
        {campaignData?.reward_type === "Discount" && "%"}
      </div>
    </>
  );
  const rewardOther = (
    <>
      <div className="mt-2" style={{ fontSize: "18px", color: "#3D3E41" }}>
        {campaignData?.reward_type === "Other" && (
          <div>{campaignData?.reward}</div>
        )}
      </div>
    </>
  );

  const videoDataattedDate = moment(campaignData?.end_date).format(
    "YYYY-MM-DD"
  );
  const EndDate = (
    <>
      <div className="date-and-time" style={{ width: "250px" }}>
        {campaignData?.ongoing ? "Ongoing" : videoDataattedDate}
      </div>
    </>
  );
  const formattedEndTime = moment(campaignData?.end_date).format("hh:mm a");

  const Time = (
    <>
      <div className="d-flex  align-items-center">
        <div className="preview-icons">{timeIcon}</div>
        <div className="preview-heading">Time</div>
      </div>
      <div className="date-and-time">{formattedEndTime}</div>
    </>
  );

  const campaignVideoLength = (
    <>
      <div className="d-flex  align-items-center mb-3">
        <div className="preview-icons">{timeLimiIcon}</div>
        <div className="preview-heading"> Video Length</div>
      </div>
      <div className="date-and-time">{campaignData?.video_time_limit}</div>
    </>
  );

  return (
    <Modal
      isOpen={showCampaignDetail}
      contentClassName="custom-campaign-detail-modal"
    >
      <QrCodeModal open={open} handleCloseQr={handleCloseQr} />
      <div
        role="button"
        style={{ position: "absolute", right: "25px", top: "25px" }}
        onClick={() =>
          dispatch(updateCampaignState({ showCampaignDetail: false }))
        }
      >
        <img src={crossIcon} />
      </div>

      <div className="form-step-4">
        <div className="d-flex justify-content-center">
          <div className="main-container" style={{ border: " 1px solid #000" }}>
            <div className="my-5">
              <img
                src={campaignData?.logo_url}
                alt=""
                style={{ maxWidth: "150px" }}
              />
            </div>
            {/* head line */}
            {headline}
            {/* hashtags */}
            {hashtags}
            {/* product image */}
            {productimage}

            {/* discription */}
            <div style={{ width: "400px" }}>
              {campaignData?.reward !== "" && (
                <>
                  <div className="d-flex mt-3">
                    <div className="d-flex align-items-center">
                      <div className="preview-icons">{rewardIcon}</div>
                      <div className="reward preview-heading">Reward</div>
                    </div>
                    {Reward}
                    {"  "}
                  </div>
                  {rewardOther}
                </>
              )}

              <div className="d-flex mt-3 mb-3">
                <div className="d-flex align-items-center">
                  <div className="preview-icons">{calenderIcon}</div>
                  <div className="preview-heading">End Date</div>
                </div>
                {EndDate}
              </div>

              <div
                className={`d-flex ${campaignData?.end_time !== "" && "mb-3"} `}
              >
                {campaignData?.end_time !== "" && Time}
              </div>
              <div className="d-flex ">
                {campaignData?.video_time_limit !== ""
                  ? campaignVideoLength
                  : null}
              </div>
            </div>
            {discriptions}

            <section className="t-and-c-section px-5 mt-3">
              <h2 style={{ color: "black" }}>Terms and Conditions</h2>
              {termAndCondition}

              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  defaultChecked
                  style={{ width: "18px", height: "18px", marginRight: "20px" }}
                />
                <span>I agree to the Terms and Conditions</span>
              </div>
            </section>

            <div className="center upload-button mt-5">
              <button
                className="btn  campaign-button"
                style={{
                  width: "197px",
                  height: "56px",
                  backgroundColor: "grey",
                }}
                disabled
              >
                Upload Video
              </button>
            </div>
          </div>
          <div>
            <div
              onClick={handleCopyClick}
              role="button"
              style={{
                marginLeft: "25px",
                marginTop: "100px",
                color: "#783AD0",
                fontSize: "18px",
              }}
            >
              {copyIcon} {copied ? "Copied" : "Copy Link"}
            </div>
            <div
              onClick={() => {
                if (campaignData?.generate_qr === "Generated") {
                  handleQrClick(campaignData?._id);
                } else {
                  handleOpenQr();
                }
              }}
              role="button"
              style={{
                marginLeft: "25px",
                marginTop: "25px",
                color: "#783AD0",
                fontSize: "18px",
              }}
            >
              {qrCodeIcon} {"QR Code"}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShowCampaignDetal;
